import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1d4461de"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "clubInfoContainer" }
const _hoisted_2 = { class: "mainArea" }
const _hoisted_3 = { class: "display-3 mb-2" }
const _hoisted_4 = { class: "established" }
const _hoisted_5 = { class: "contactArea" }
const _hoisted_6 = { class: "layout gutter--md" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "flex md4" }
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "layout gutter--md" }
const _hoisted_11 = { class: "row" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "md4 flex" }, "Adresse:", -1))
const _hoisted_13 = { class: "md8 flex" }
const _hoisted_14 = { class: "row" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "md4 flex" }, "By:", -1))
const _hoisted_16 = { class: "md8 flex" }
const _hoisted_17 = { class: "row" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "md4 flex" }, "Region:", -1))
const _hoisted_19 = { class: "md8 flex" }
const _hoisted_20 = { class: "row" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "md4 flex" }, "Handicapvenlig:", -1))
const _hoisted_22 = {
  key: 0,
  class: "md8 flex"
}
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Ja", -1))
const _hoisted_24 = [
  _hoisted_23
]
const _hoisted_25 = {
  key: 1,
  class: "md8 flex"
}
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Nej", -1))
const _hoisted_27 = [
  _hoisted_26
]
const _hoisted_28 = { class: "row" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "md4 flex" }, "Telefon:", -1))
const _hoisted_30 = { class: "md8 flex" }
const _hoisted_31 = ["href"]
const _hoisted_32 = { class: "row" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "md4 flex" }, "Email:", -1))
const _hoisted_34 = { class: "md8 flex" }
const _hoisted_35 = ["href"]
const _hoisted_36 = {
  key: 0,
  class: "row"
}
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "md4 flex" }, "Find os på nettet:", -1))
const _hoisted_38 = { class: "md8 flex center" }
const _hoisted_39 = { key: 0 }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "center" }, "Åbningstider på vej", -1))
const _hoisted_41 = [
  _hoisted_40
]
const _hoisted_42 = {
  key: 1,
  class: "layout gutter--md"
}
const _hoisted_43 = { class: "flex md3" }
const _hoisted_44 = { class: "flex md3" }
const _hoisted_45 = { class: "flex md5" }
const _hoisted_46 = { key: 0 }
const _hoisted_47 = ["src"]
const _hoisted_48 = { class: "layout gutter--md" }
const _hoisted_49 = { key: 0 }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Kontakt informationer er på vej...", -1))
const _hoisted_51 = [
  _hoisted_50
]
const _hoisted_52 = { key: 1 }
const _hoisted_53 = { class: "row" }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "md4 flex" }, "Navn:", -1))
const _hoisted_55 = { class: "md8 flex" }
const _hoisted_56 = { class: "row" }
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "md4 flex" }, "Telefon:", -1))
const _hoisted_58 = { class: "md8 flex" }
const _hoisted_59 = ["href"]
const _hoisted_60 = { class: "row" }
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "md4 flex" }, "Email:", -1))
const _hoisted_62 = { class: "md8 flex" }
const _hoisted_63 = ["href"]
const _hoisted_64 = { class: "row justify--center mt-4" }
const _hoisted_65 = { class: "flex md5 center" }
const _hoisted_66 = /*#__PURE__*/_createTextVNode("Til til klublisten")
const _hoisted_67 = { class: "flex md5 center" }
const _hoisted_68 = /*#__PURE__*/_createTextVNode("Til forsiden")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_QuillEditor = _resolveComponent("QuillEditor")!
  const _component_va_collapse = _resolveComponent("va-collapse")!
  const _component_va_icon = _resolveComponent("va-icon")!
  const _component_it_tooltip = _resolveComponent("it-tooltip")!
  const _component_va_accordion = _resolveComponent("va-accordion")!
  const _component_va_button = _resolveComponent("va-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h3", _hoisted_3, _toDisplayString(_ctx.klubData.klubKlubnavn), 1),
      _createElementVNode("p", _hoisted_4, [
        _createElementVNode("sup", null, [
          _createElementVNode("i", null, "Etableret: " + _toDisplayString(_ctx.klubData.klubEtableringsaar.slice(0,4)), 1)
        ])
      ]),
      _createVNode(_component_QuillEditor, {
        ref: "clubDescription",
        contentType: "html",
        class: "clubDescriptionFront",
        readOnly: true,
        content: _ctx.klubData.klubBeskrivelse,
        "onUpdate:content": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.klubData.klubBeskrivelse) = $event)),
        theme: "bubble"
      }, null, 8, ["content"])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", null, [
        _createVNode(_component_va_accordion, {
          multiply: "",
          modelValue: _ctx.expandedAccordions,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.expandedAccordions) = $event)),
          id: "clubAccordion",
          color: "#b4003a"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_va_collapse, { header: "Klublogo" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("img", {
                        class: "logoImg",
                        src: _ctx.extractLogoURLFromClubLogoData(_ctx.klubData.klubLogo),
                        label: "Klublogo"
                      }, null, 8, _hoisted_9)
                    ])
                  ])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_va_collapse, { header: "Klubinformation" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _hoisted_12,
                    _createElementVNode("p", _hoisted_13, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.klubData.klubVejnavn), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _hoisted_15,
                    _createElementVNode("p", _hoisted_16, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.klubData.klubPostnummer + ' ' + _ctx.klubData.klubBy), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_17, [
                    _hoisted_18,
                    _createElementVNode("p", _hoisted_19, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.klubData.klubRegion.slice(7).trim()), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_20, [
                    _hoisted_21,
                    (_ctx.klubData.klubKoerestolsvenlig === true)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_22, _hoisted_24))
                      : (_openBlock(), _createElementBlock("p", _hoisted_25, _hoisted_27))
                  ]),
                  _createElementVNode("div", _hoisted_28, [
                    _hoisted_29,
                    _createElementVNode("p", _hoisted_30, [
                      _createElementVNode("strong", null, [
                        _createElementVNode("a", {
                          href: 'tel:' + _ctx.klubData.klubTelefonnummer
                        }, _toDisplayString(_ctx.klubData.klubTelefonnummer), 9, _hoisted_31)
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_32, [
                    _hoisted_33,
                    _createElementVNode("p", _hoisted_34, [
                      _createElementVNode("strong", null, [
                        _createElementVNode("a", {
                          href: 'mailto:' + _ctx.klubData.klubEmail,
                          target: "_blank"
                        }, _toDisplayString(_ctx.klubData.klubEmail), 9, _hoisted_35)
                      ])
                    ])
                  ]),
                  ((_ctx.klubData.klubHjemmeside !== null && _ctx.klubData.klubHjemmeside !== '') || (_ctx.klubData.klubFacebook !== '' && _ctx.klubData.klubFacebook !== null))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                        _hoisted_37,
                        _createElementVNode("div", _hoisted_38, [
                          (_ctx.klubData.klubHjemmeside !== null && _ctx.klubData.klubHjemmeside !== '')
                            ? (_openBlock(), _createBlock(_component_it_tooltip, {
                                key: 0,
                                content: "Besøg vores hjemmeside",
                                placement: "bottom"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_va_icon, {
                                    tag: "a",
                                    href: _ctx.klubData.klubHjemmeside,
                                    target: "_blank",
                                    rel: "noopener noreferrer",
                                    class: "netIcons",
                                    color: "#b4003a",
                                    size: "large",
                                    name: "screen_search_desktop"
                                  }, null, 8, ["href"])
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          (_ctx.klubData.klubFacebook !== null && _ctx.klubData.klubFacebook !== '')
                            ? (_openBlock(), _createBlock(_component_it_tooltip, {
                                key: 1,
                                content: "Besøg os på Facebook",
                                placement: "bottom"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_va_icon, {
                                    tag: "a",
                                    href: _ctx.klubData.klubFacebook,
                                    target: "_blank",
                                    rel: "noopener noreferrer",
                                    class: "netIcons",
                                    color: "#b4003a",
                                    size: "large",
                                    name: "facebook"
                                  }, null, 8, ["href"])
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_va_collapse, { header: "Åbningstider" }, {
              default: _withCtx(() => [
                (this.openingHours.length === 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_39, _hoisted_41))
                  : (_openBlock(), _createElementBlock("div", _hoisted_42, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.openingHours, (openingHour) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "row",
                          key: openingHour.id
                        }, [
                          _createElementVNode("div", _hoisted_43, [
                            _createElementVNode("p", null, _toDisplayString(_ctx.convertOe(openingHour.aabningstider_dag)), 1)
                          ]),
                          _createElementVNode("div", _hoisted_44, [
                            _createElementVNode("p", null, _toDisplayString(openingHour.aabningstider_aaben.slice(0, 5)) + " - " + _toDisplayString(openingHour.aabningstider_luk.slice(0, 5)), 1)
                          ]),
                          _createElementVNode("div", _hoisted_45, [
                            _createElementVNode("p", null, _toDisplayString((openingHour.aabningstider_kommentar === null ? '' : openingHour.aabningstider_kommentar)), 1)
                          ])
                        ]))
                      }), 128))
                    ]))
              ]),
              _: 1
            }),
            _createVNode(_component_va_collapse, { header: "Kort" }, {
              default: _withCtx(() => [
                ((_ctx.klubData.klubVejnavn !== undefined && _ctx.klubData.klubPostnummer !== undefined && _ctx.klubData.klubBy !== undefined))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                      _createElementVNode("iframe", {
                        width: "100%",
                        height: "250",
                        frameborder: "0",
                        style: {"border":"0"},
                        src: 'https://www.google.com/maps/embed/v1/place?key=AIzaSyBXFlN0nAeVCs6STM6aZymlC9eYR3i37jQ&q=' + _ctx.klubData.klubVejnavn + '+'  + _ctx.klubData.klubPostnummer + '+' + _ctx.klubData.klubBy,
                        allowfullscreen: ""
                      }, "\n            ", 8, _hoisted_47)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_va_collapse, { header: "Klubansvarlig" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_48, [
                  (_ctx.klubData.klubAnsvarligId === 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_49, _hoisted_51))
                    : (_openBlock(), _createElementBlock("div", _hoisted_52, [
                        _createElementVNode("div", _hoisted_53, [
                          _hoisted_54,
                          _createElementVNode("p", _hoisted_55, [
                            _createElementVNode("strong", null, _toDisplayString(_ctx.medlemData.brugerFornavn + ' ' + _ctx.medlemData.brugerEfternavn), 1)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_56, [
                          _hoisted_57,
                          _createElementVNode("p", _hoisted_58, [
                            _createElementVNode("strong", null, [
                              _createElementVNode("a", {
                                href: 'tel:' + _ctx.medlemData.brugerTelefon
                              }, _toDisplayString(_ctx.medlemData.brugerTelefon), 9, _hoisted_59)
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_60, [
                          _hoisted_61,
                          _createElementVNode("p", _hoisted_62, [
                            _createElementVNode("strong", null, [
                              _createElementVNode("a", {
                                href: 'mailto:' + _ctx.medlemData.brugerEmail
                              }, _toDisplayString(_ctx.medlemData.brugerEmail), 9, _hoisted_63)
                            ])
                          ])
                        ])
                      ]))
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createElementVNode("div", _hoisted_64, [
          _createElementVNode("div", _hoisted_65, [
            _createVNode(_component_va_button, {
              class: "btn",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$router.push('/klubber')))
            }, {
              default: _withCtx(() => [
                _hoisted_66
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_67, [
            _createVNode(_component_va_button, {
              class: "btn",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$router.push('/')))
            }, {
              default: _withCtx(() => [
                _hoisted_68
              ]),
              _: 1
            })
          ])
        ])
      ])
    ])
  ]))
}